
import React from 'react';
import { ShieldAlert, Calendar, ArrowLeft, Info, Lock, ExternalLink, Scale, AlertCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { MAIN_COUPON_CODE } from '../constants';

const LegalDisclaimer: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-16 animate-in fade-in slide-in-from-bottom-4 duration-700">
      <Link to="/" className="inline-flex items-center gap-2 text-gray-500 hover:text-white mb-12 transition-colors font-black uppercase text-[10px] tracking-widest">
        <ArrowLeft size={16} /> Back to Home
      </Link>

      <div className="mb-12">
        <h1 className="text-4xl md:text-5xl font-black text-white uppercase tracking-tighter mb-4 italic">Legal Disclaimer</h1>
        <p className="text-gray-500 font-bold uppercase tracking-widest text-[10px] mb-12 flex items-center gap-2">
          <Calendar size={12} /> Last Updated: January 19, 2025
        </p>

        <div className="space-y-12 text-gray-400 leading-relaxed font-medium">
          {/* Section 1 */}
          <section>
            <h2 className="text-xl font-black text-white mb-4 uppercase tracking-tight flex items-center gap-3 italic">
              1. General Information
            </h2>
            <p>
              The information provided by <span className="text-white">PW Coupon Hub</span> ("we," "us," or "our") on this website is for general informational purposes only. All information on the site is provided in good faith, however, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the site.
            </p>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-xl font-black text-white mb-4 uppercase tracking-tight flex items-center gap-3 italic">
              2. Affiliate Disclosure
            </h2>
            <p>
              This website participates in the <span className="text-white underline decoration-blue-500">Physics Wallah Student Ambassador Program</span>. We may receive a small commission when you use our verified coupon codes (e.g., <span className="text-blue-400 font-bold">{MAIN_COUPON_CODE}</span>) to purchase batches on the official Physics Wallah platform (pw.live). This commission comes at <span className="text-white font-bold">no additional cost to you</span>. Our goal is to provide students with the highest possible savings while supporting the maintenance of this resource hub.
            </p>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-xl font-black text-white mb-4 uppercase tracking-tight flex items-center gap-3 italic">
              3. No Official Affiliation
            </h2>
            <p>
              PW Coupon Hub is an independent student resource and is <span className="text-white font-bold underline decoration-red-500">not the official website</span> of Physics Wallah Private Limited. The official platform can be found at <a href="https://www.pw.live" target="_blank" className="text-blue-500 hover:text-blue-400 transition-colors underline">www.pw.live</a>. All logos, trademarks, and brand names are the property of their respective owners.
            </p>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-xl font-black text-white mb-4 uppercase tracking-tight flex items-center gap-3 italic">
              4. "As-Is" Discount Guarantee
            </h2>
            <p>
              While we verify codes daily, coupon validity is determined solely by Physics Wallah. Discounts may vary based on user history, batch selection, and current promotional cycles. We are not responsible if a code fails to provide a specific discount amount at any given time.
            </p>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-xl font-black text-white mb-4 uppercase tracking-tight flex items-center gap-3 italic">
              5. Limitation of Liability
            </h2>
            <p>
              Under no circumstance shall we have any liability to you for any loss or damage of any kind incurred as a result of the use of the site or reliance on any information provided on the site. Your use of the site and your reliance on any information on the site is solely at your own risk.
            </p>
          </section>
        </div>
      </div>

      <div className="pt-24 border-t border-white/5 text-center">
        <p className="text-[10px] text-gray-800 font-black uppercase tracking-[0.6em] italic">
          © 2025 PW Coupon Hub • Independent Ambassador Portal
        </p>
      </div>
    </div>
  );
};

export default LegalDisclaimer;
